import Chat from "./chat.model";

class App {

  constructor() {
    if (!appInstance) {
      this.chats = []
      appInstance = this;
    }
    return appInstance;
  }

  createChat(){
    let chat = new Chat();
    this.chats.push(chat)
    return chat;
  }

}

var appInstance = new App();
export default appInstance;